import { InertiaApp } from '@inertiajs/inertia-vue';
import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import route from 'ziggy';
import { Ziggy } from '@web/ziggy-web-routes.js';
import VueResize from 'vue-resize';
import 'vue-resize/dist/vue-resize.css';
import vueHeadful from 'vue-headful';
import Vue2TouchEvents from 'vue2-touch-events';
import { flare } from '@flareapp/flare-client';
import { flareVue } from '@flareapp/flare-vue';
import Analytics from '@whisper/utils/analytics';
import get from 'lodash/get';
import { InertiaProgress } from '@inertiajs/progress';

if (get(window, 'location.host') !== 'imagesalon.com') {
  Vue.config.devtools = true;
}

flare.light();
Vue.use(flareVue);

Vue.use(Vue2TouchEvents);
Vue.use(VueResize); // Detect DOM element resizing, eg in <tis-icon-topped-wrapper>
Vue.use(InertiaApp); // Intertia Props from Backend, see Notion.so docs
Vue.use(vClickOutside); // detect taps/clicks outside the component, eg menu dropdown expansion panel
Vue.component('VueHeadful', vueHeadful); // set <head> data like titles
Vue.use(Analytics);

InertiaProgress.init({
  // The delay after which the progress bar will
  // appear during navigation, in milliseconds.
  delay: 150,

  // The color of the progress bar.
  color: '#bf9c5f',

  // Whether to include the default NProgress styles.
  includeCSS: true,

  // Whether the NProgress spinner will be shown.
  showSpinner: false,
});

const app = document.getElementById('app');

// todo: refactor this to dynamic imports once we have webpack 5
const files = require.context('./', true, /\.vue$/i);

Vue.mixin({
  filters: {
    telHref(value) {
      if (value) {
        return `tel:${value.replace(/\D+/g, '')}`;
      }
    },
  },
  methods: {
    route: (name, params, absolute) => route(name, params, absolute, Ziggy),
  },
});

new Vue({
  render: (h) => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: (page) => files(`./pages/${page}.vue`).default,
      transformProps: (props) => {
        if (Vue.analytics && Vue.analytics.enabled) {
          Vue.analytics.processWebsiteInertiaRequest(props);
        }

        return props;
      },
    },
  }),
}).$mount(app);
